<template>
  <section class="pmp-card">
    <div class="pmp-section-head">
      <h1 class="pmp-section-title">Producto y color</h1>
    </div>

    <PMPDropdown
      v-model="localForm.producto"
      label="Producto"
      placeholder="Selecciona producto"
      :options="productos"
      :error="errors.producto"
      error-message="Selecciona un producto."
      @select="handleProductoSelect"
    />

    <PMPDropdown
      v-model="localForm.color"
      label="Color"
      placeholder="Selecciona color"
      :options="colores"
      :error="errors.color"
      error-message="Selecciona un color."
      @select="handleColorSelect"
    />

    <PMPField
      :model-value="localForm.cantidadPigmentoGr"
      id="pmp-cantidad-pigmento-gr"
      label="Cantidad de pigmento (Gr)"
      type="text"
      inputmode="decimal"
      min="0"
      step="0.01"
      max-digits="4"
      placeholder="Ej. 250"
      :error="errors.cantidadPigmentoGr"
      error-message="Ingresa la cantidad de pigmento en gramos."
      @update:modelValue="handleCantidadPigmentoInput"
    />

    <div class="pmp-field">
      <button
        type="button"
        class="pmp-aditivo-toggle"
        :class="{ 'is-active': localForm.aditivo }"
        role="switch"
        :aria-checked="localForm.aditivo"
        aria-label="Aditivo"
        @click="toggleAditivo"
      >
        <i
          class="bi"
          :class="localForm.aditivo ? 'bi-check-circle-fill' : 'bi-x-circle'"
          aria-hidden="true"
        ></i>
        <span>{{ localForm.aditivo ? "Con aditivo" : "Sin aditivo" }}</span>
      </button>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

import PMPField from "../components/PMPField.vue";
import PMPDropdown from "../components/PMPDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  productos: {
    type: Array,
    default: () => [],
  },
  colores: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleProductoSelect(option) {
  localForm.value.productoLabel = option.label;
  localForm.value.productoCode = option.code || "";
  notifyFieldChange("producto");
}

function handleColorSelect(option) {
  localForm.value.colorLabel = option.label;
  localForm.value.colorHex = option.hex || "";
  notifyFieldChange("color");
}

function toggleAditivo() {
  localForm.value.aditivo = !localForm.value.aditivo;
}

function handleCantidadPigmentoInput(value) {
  localForm.value.cantidadPigmentoGr = value; // ← PMPField ya filtra
  notifyFieldChange("cantidadPigmentoGr");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
